import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { AppMenuComponent } from './app.menu.component';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppMenuComponent]
})
export class AppSidebarComponent {
  readonly layoutService = inject(LayoutService);
  readonly el = inject(ElementRef);
}
